import { render, staticRenderFns } from "./UnauthorisedMedianCutApprove.vue?vue&type=template&id=9ba41fb8"
import script from "./UnauthorisedMedianCutApprove.vue?vue&type=script&lang=js"
export * from "./UnauthorisedMedianCutApprove.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports